import { AfterViewInit, Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'bepatient-image',
  templateUrl: './bepatient-image.component.html',
  styleUrls: ['./bepatient-image.component.scss'],
  standalone: false
})
export class BepatientImageComponent implements OnInit, AfterViewInit {
  @Input() imageId: string;
  @Input() imageClass: string;
  @Input() parentElementId: string;
  @Input() imageSrc: string;
  @Input() imageStyle: string;
  spinner: HTMLElement;

  constructor() {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.spinner = document.createElement('ion-spinner');
    this.spinner.setAttribute('name', 'dots');
    this.spinner.style.alignSelf = 'center';
    this.spinner.style.top = '16px';

    const img = document.getElementById(this.imageId);
    const frame = document.getElementById(this.parentElementId);
    if (frame) {
      frame.prepend(this.spinner);
    }

    if (!img) {
      this.spinner.remove();
    } else {
      img.addEventListener('load', () => {
        this.spinner.remove();
      });
      img.addEventListener('error', () => {
        this.spinner.remove();
      });
    }
  }
}
